import { PropsWithChildren } from "react";

import { Flex } from "@chakra-ui/react";

function ActionMenu({ children }: PropsWithChildren<unknown>) {
  return (
    <Flex
      align="center"
      bg="background.base"
      borderTop="1px"
      borderTopColor="inherit"
      columnGap={4}
      h="auto"
      justifyContent="end"
      px={4}
      py={4}
      w="full"
    >
      {children}
    </Flex>
  );
}

export default ActionMenu;
